import { SORT_ASC, SORT_DESC, SORT_PARAM_KEY } from "src/_Globals/urls";
import { urlToMrtSorting } from "src/components/Grid/hooks/gridUrlSync/useGridSortUrlSync";

export const API_EMPTY_SORT: AxiosParams = {};

const urlToSortAxiosParams = (sortString: string): AxiosParams => {
    return Object.fromEntries(
        urlToMrtSorting(sortString).map(({ id, desc }) => [`order[${id}]`, desc ? SORT_DESC : SORT_ASC]),
    );
};

export type Options = {
    searchParams?: URLSearchParams;
};
export const useApiSortUrlSync = (options?: Options) => {
    const { searchParams = new URLSearchParams() } = options || {};
    const sortingSearchParam = searchParams.get(SORT_PARAM_KEY);

    const initialSort = sortingSearchParam === null ? API_EMPTY_SORT : urlToSortAxiosParams(sortingSearchParam);

    return { sort: initialSort };
};
